export interface IMembersSelectorUser {
  id: number
  display_name: string
  userIdentity: string
  image_url: string | null
  cantBeSelectedReason?: string
  added_at?: Date
}

export interface IMembersSelectorGroup {
  id: number
  name: string
  cantBeSelectedReason?: string
  added_at?: Date
}

export enum MemberTypeEnum {
  USER = 'USER',
  GROUP = 'GROUP'
}

export type IMembersSelectorMembers = {
  users: IMembersSelectorUser[]
  groups: IMembersSelectorGroup[]
}

export interface IMembersSelectorContext {
  isMembersListShown: boolean
  isAddressBookActive: boolean
  query: string
  autocompleteUsers: IMembersSelectorUser[]
  autocompleteGroups: IMembersSelectorGroup[]
  selectedMembers: IMembersSelectorMembers
  addUser: (user: IMembersSelectorUser) => void
  addGroup: (user: IMembersSelectorGroup) => void
  removeUser: (user: IMembersSelectorUser) => void
  removeGroup: (user: IMembersSelectorGroup) => void
  setQuery: (q: string) => void
  setShowAddressBook: (show: boolean) => void
  setShowMembersList: (show: boolean) => void
  reset: () => void
  setSelectedMembers: (selectedMembers: IMembersSelectorMembers) => void
  setAddressBook: (addressBook?: IMembersSelectorMembers) => void
  setFoundMembers: (membersFound: IMembersSelectorMembers) => void
  setNotifyParentOnChangeSelectedMembers: (
    notifyParentOnChangeSelectedMembers: (
      members: IMembersSelectorMembers
    ) => void
  ) => void
}
